import React, {Component} from 'react';
import {
  Button,
  Table,
  Input
} from 'reactstrap';


import { FaSave, FaPencilAlt} from 'react-icons/fa';



class TablaCalificaciones extends Component {

    constructor() {
        super();
        this.state = {
            notas:[
                {
                alumno: '',
                nota:''
            }
            ]
        }
    }


    render(){
        const {estudiantes, actividad, cambiarNota, guardarNotaIndividual, editarNotaIndividual} = this.props; 

        const nombreActividad = actividad!==undefined && actividad!=="" && actividad!=="Seleccione"  ? JSON.parse(actividad).nombre : 'Sin actividad'; 

        return (

            <div>
                {estudiantes.length>0 ? (
                    <Table size="sm" striped bordered className="tabla-general">
                        <thead>
                            <tr>
                                <th>Alumno</th>
                                <th className="ocultar-en-somen" >Actividad</th>
                                {actividad!=='' && actividad!=='Seleccione' && <th style={{width:80}}>Nota</th>}
                                {actividad!=='' && actividad!=='Seleccione' && <th className="text-center">Opciones</th>}         
                            </tr>

                        </thead>
                        <tbody>

                            {estudiantes.map((e, index) => {
                                return (
                                    <tr key={e.idEstudiante}>

                                        <td>{e.nombreEstudiante}</td>
                                        <td className="ocultar-en-somen">{nombreActividad}</td>

                                        {actividad!=='' && actividad!=='Seleccione' && 
                                            <td>
                                                <Input type="text" 
                                                onChange={e => cambiarNota(e, index) }  
                                                value={ e.nota ? e.nota : '' } />
        
                                            </td>
                                        }
                                        {actividad!=='' && actividad!=='Seleccione' && 
                                            <td className="text-center td-botones">
                                                {e.idNota!=="" ? (
                                                    <Button color="success" className="btn-tabla"   onClick={()=>editarNotaIndividual(e)}   > <FaPencilAlt/></Button>
                                                
                                                ) : (
                                                    <Button color="success" className="btn-tabla"  onClick={()=>guardarNotaIndividual(e)}  > <FaSave/></Button>
                                                )}
                                            
                                
                                            </td>
                                        }
                                    </tr>
                                )  
                            })}

                        </tbody>

                    </Table>   
                ) : null}
                 
            </div>
        );

    }
};

export default TablaCalificaciones;
